import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { jwtDecode } from "jwt-decode";
import { authClient } from "../services/auth/authClient";

const name = "auth";
const initialState = createInitialState();

export const loginWithAad = createAsyncThunk(
  `${name}/log-in-aad`,
  ({ email, token }) =>
    authClient.post(`log-in-aad`, {
      email: email,
      token: token,
    })
);

export const refreshJwtByAad = createAsyncThunk(
  `${name}/refreshJwt`,
  ({ email, token }) =>
    authClient.post(`log-in-aad`, {
      email: email,
      token: token,
    })
);

const slice = createSlice({
  name,
  initialState,
  reducers: {
    logout(state) {
      state.user = null;
      localStorage.removeItem("jwtToken");
      localStorage.removeItem("aadToken");
      window.location.href = window.location.origin + "/";
    },

    changeMfa(state) {
      state.isAuthenticated = false;
      state.isMfa = false;
    },

    resetLogin() {
      localStorage.removeItem("jwtToken");
    },
  },
  extraReducers: (builder) => {
    builder.addCase(refreshJwtByAad.pending, (state) => {
      state.error = null;
      state.isLoading = true;
    });
    builder.addCase(refreshJwtByAad.fulfilled, (state, action) => {
      if (action.payload.data) {
        localStorage.setItem("jwtToken", action.payload.data.token);
      }
      state.isAuthenticated = true;
      state.isLoading = false;
      window.location.href = "/";
    });
    builder.addCase(refreshJwtByAad.rejected, (state, action) => {
      state.isLoading = false;
      state.error = action.error;
    });

    builder.addCase(loginWithAad.pending, (state) => {
      state.error = null;
      state.isMfa = false;
      state.isLoading = true;
    });
    builder.addCase(loginWithAad.fulfilled, (state, action) => {
      const azureToken = action.meta.arg.token;
      if (action.payload && azureToken) {
        localStorage.setItem("aadToken", azureToken);
        localStorage.setItem("jwtToken", action.payload.data.token);
      }
      state.isMfa = false;
      state.isAuthenticated = true;
      state.isLoading = false;
      window.location.href = "/";
    });
    builder.addCase(loginWithAad.rejected, (state, action) => {
      if (action.error.name === "TypeError") {
        state.error = {
          message:
            "Sistem genelinde bir hata oluştu. Lütfen Sistem Geliştirme Birimine bildiriniz.",
        };
      } else {
        state.error = action.error;
      }
      state.isLoading = false;
      state.isMfa = false;
    });
  },
});

// Exports
export const authActions = { ...slice.actions };
export const authReducer = slice.reducer;

// Implementation
function createInitialState() {
  let user = localStorage.getItem("jwtToken");
  const token = user;
  if (user) {
    user = jwtDecode(user);
    const tokenDate = new Date(user.exp * 1000);
    if (tokenDate <= new Date()) {
      localStorage.removeItem("jwtToken");
      window.location.href = "/";
    } else {
      user.token = token;
    }
  }
  return {
    user: user || null,
    error: null,
    isMfa: false,
    isAuthenticated: !!user,
    isLoading: false,
    roles: [],
  };
}
